
Checkout.Payment.Totals = function(checkout, payment) {
	var totals = this;

	this.$wrap = $('#payment-sidebar-pricing');
	this.$subtotal = $('#payment-sidebar-subtotal');
	this.$shipping = $('#payment-sidebar-shipping');
	this.$shippingOverride = $('#payment-sidebar-shipping-override');
	this.$tax = $('#payment-sidebar-tax');
	this.$taxExempt = $('#payment-sidebar-tax-exempt');
	this.$total = $('#payment-sidebar-total');
	this.$remaining = $('#payment-sidebar-remaining');

	this.init = function() {
		totals.listen();
	};

	this.listen = function() {

		totals.$shipping.click(function() {
			$('html,body').animate(
				{ 'scrollTop': checkout.shipping.$anchor.offset().top },
				500
			);
		});

	};

	this.buildContent = function() {
		var values = checkout.cart.totals.values;

		totals.$subtotal.children('span').html('$'+commaSeparate(values.subtotal));

		totals.$shipping.children('span').html('$'+commaSeparate(values.origShipping));
		totals.$shippingOverride.children('span').html('$'+commaSeparate(values.shipping));

		if (values.origShipping != values.shipping) {
			totals.$shipping.children('span').css('text-decoration', 'line-through');
			totals.$shippingOverride.show();
		} else {
			totals.$shipping.children('span').css('text-decoration', '');
			totals.$shippingOverride.hide();
		}

		totals.$tax.children('span').html('$'+commaSeparate(values.origTax));
		totals.$total.children('span').html('$'+commaSeparate(values.total));

		if (parseFloat(values.origTax))
			totals.$tax.show();
		else
			totals.$tax.hide();

		if (values.origTax != values.tax) {
			totals.$tax.children('span').css('text-decoration', 'line-through');
			totals.$taxExempt.show();
		} else {
			totals.$tax.children('span').css('text-decoration', '');
			totals.$taxExempt.hide();
		}

		totals.buildFees();
		totals.buildPaymentMethods();
	};

	this.buildFees = function() {
		var values = checkout.cart.totals.values,
			fees = [];

		for (var feeLabel in values.fees)
			fees.push(
				'<div class="fee">'
					+ feeLabel + ' Fee'
					+ '<span>'
						+ '$' + commaSeparate(parseFloat(values.fees[feeLabel]).toMoney())
					+ '</span>'
				+ '</div>'
			);

		totals.$wrap
			.children('.fee')
			.remove();

		if (fees.length)
			totals.$total.before(fees);

	};

	this.buildPaymentMethods = function() {
		var values = checkout.cart.totals.values,
			rows = [],
			displayRemaining = parseFloat(values.remaining);

		$.each(payment.balanceMethods, function(i, method) {
			var balance = (parseFloat(values.balances[method.label]) || 0);

			if (balance)
				rows.push(
					'<div class="payment-summary">'
						+ method.label
						+ '<span>'
							+ '-$' + commaSeparate(balance.toMoney())
						+ '</span>'
					+ '</div>'
				);
		});

		checkout.payment.$methodContainer.find('.payment-method:visible')
			.each(function(i, methodWrap) {
				var method = checkout.payment.methods[$(methodWrap).data('methodKey')],
					amt = checkout.payment.getMethodAmt(method);

				displayRemaining -= amt;
                var method_label = method.label;
                if (method.getStoredPaymentType && method.getStoredPaymentType().match(/paypal/)) 
                   method_label = 'PayPal'; 

				rows.push(
					'<div class="payment-summary">'
						+ method_label
						+ '<span>'
							+ '-$' + commaSeparate(amt.toMoney())
						+ '</span>'
					+ '</div>'
				);

			});

		totals.$wrap
			.children('.payment-summary')
			.remove();

		if (displayRemaining < 0)
			displayRemaining = 0;

		totals.$remaining.children('span').html('$'+commaSeparate(displayRemaining.toMoney()));

		if (rows.length) {
			totals.$total.after(rows.join("\n"));
			totals.$remaining.show();
		} else
			totals.$remaining.hide();

	};

	this.init();
};

